module.exports = __webpack_public_path__ + "img/IMG_9786_L_Foamcore_MockedUp.65a768e9.jpg";